import { describeError } from "@/lib/api/client";
import type { RecordEntry } from "@/lib/posting";
import RecordList from "./RecordList";
import { SectionCard } from "./parts";

/** Every event on the posting and its application, oldest first. */
export default function RecordCard({
    error,
    entries,
}: {
    error: Error | null;
    entries: RecordEntry[];
}) {
    return (
        <SectionCard
            className="gap-3 px-5 py-[18px]"
            title="Record"
            caption="Every event, oldest first, from the catalogue and your envoy."
        >
            {error ? (
                <p className="m-0 text-ui text-fg-muted">{describeError(error)}</p>
            ) : (
                <RecordList entries={entries} />
            )}
        </SectionCard>
    );
}
